/* jb-cadencia — fila única de pop-ups da Jardim Brasil.
   Ordem: cookies → flore.SER → lead → login social (Google/Hiko).
   Regra de ouro: só um por vez, e nunca em cima da chegada do cliente. */
(function () {
  'use strict';
  if (window.jbFila) return;

  /* páginas-ferramenta: nenhum pop-up (a pessoa está usando a câmera) */
  var SILENCIO = /^\/pages\/meu-ritual(\/|$|\?)/.test(location.pathname + (location.search ? '?' : ''));

  var ESPERA_APOS_COOKIE = 15000;   /* folga depois que o cookie é respondido */
  var INTERVALO = 20000;            /* silêncio mínimo entre um pop-up e o próximo */
  var ESPERA_GOOGLE = 90000;        /* login social só bem depois, ou na 2ª página */
  var LIMITE_COOKIE = 30000;        /* se ninguém responde o cookie, seguimos mesmo assim */

  var raiz = document.documentElement;
  var fila = [];          /* {id, prioridade, abrir, pronto} */
  var aberto = null;      /* id do pop-up na tela */
  var ultimoFecho = 0;
  var cookieOk = false;
  var t0 = 0;             /* momento em que o caminho ficou livre */

  function agora() { return Date.now(); }

  function log() { /* silencioso em produção */ }

  /* ---------------------------------------------------- páginas da visita */
  var paginas = 1;
  try {
    paginas = Number(sessionStorage.getItem('jb_cad_paginas') || '0') + 1;
    sessionStorage.setItem('jb_cad_paginas', String(paginas));
  } catch (e) { paginas = 1; }

  /* -------------------------------------------------------- banner cookie */
  function cookieNaTela() {
    var el = document.querySelector('.hdt-drawer-cookie, [class*="popup_cookies"]');
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) < 0.05) return false;
    var r = el.getBoundingClientRect();
    if (r.height < 20 || r.width < 40) return false;
    var alt = window.innerHeight || document.documentElement.clientHeight || 0;
    return r.bottom > 4 && r.top < alt - 4;
  }

  function liberarCaminho() {
    if (cookieOk) return;
    cookieOk = true;
    t0 = agora();
    raiz.classList.remove('jb-cad-espera');
    setTimeout(rodar, ESPERA_APOS_COOKIE);
    setTimeout(function () { permitirGoogle(); }, ESPERA_GOOGLE);
  }

  raiz.classList.add('jb-cad-espera');

  function vigiarCookie() {
    if (!cookieNaTela()) { liberarCaminho(); return; }
    var t = setInterval(function () {
      if (!cookieNaTela()) { clearInterval(t); liberarCaminho(); }
    }, 500);
    setTimeout(function () { clearInterval(t); liberarCaminho(); }, LIMITE_COOKIE);
  }

  /* --------------------------------------------------------------- a fila */
  function podeAgora() {
    if (!cookieOk) return false;
    if (aberto) return false;
    if (cookieNaTela()) return false;
    if (agora() - t0 < ESPERA_APOS_COOKIE) return false;
    if (ultimoFecho && agora() - ultimoFecho < INTERVALO) return false;
    /* se a pessoa está escrevendo em algum campo, não interrompe */
    var a = document.activeElement;
    if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return false;
    return true;
  }

  function rodar() {
    if (SILENCIO) return;
    if (!podeAgora()) return;
    fila.sort(function (x, y) { return x.prioridade - y.prioridade; });
    for (var i = 0; i < fila.length; i++) {
      if (!fila[i].pronto()) continue;
      var item = fila.splice(i, 1)[0];
      aberto = item.id;
      try { item.abrir(); } catch (e) { aberto = null; }
      return;
    }
  }

  /* Pede a vez. `pronto` diz se o gatilho daquele pop-up já aconteceu. */
  function pedir(id, abrir, opcoes) {
    opcoes = opcoes || {};
    for (var i = 0; i < fila.length; i++) if (fila[i].id === id) return;
    fila.push({
      id: id,
      prioridade: opcoes.prioridade == null ? 50 : opcoes.prioridade,
      abrir: abrir,
      pronto: opcoes.pronto || function () { return true; }
    });
    rodar();
  }

  function liberar(id) {
    if (aberto === id || id == null) { aberto = null; ultimoFecho = agora(); }
    setTimeout(rodar, INTERVALO);
  }

  function ocupado() { return !!aberto || cookieNaTela(); }

  /* ------------------------------------------------- login social (Hiko) */
  var googleLiberado = false;
  var googlePendente = [];

  function envolverGoogle(g) {
    try {
      if (!g || !g.accounts || !g.accounts.id || g.accounts.id.__jbCad) return;
      var orig = g.accounts.id.prompt;
      if (typeof orig !== 'function') return;
      g.accounts.id.prompt = function () {
        var args = arguments, eu = this;
        if (googleLiberado) return orig.apply(eu, args);
        googlePendente.push(function () { try { orig.apply(eu, args); } catch (e) { } });
        return undefined;
      };
      g.accounts.id.__jbCad = 1;
    } catch (e) { }
  }

  function permitirGoogle() {
    if (SILENCIO) return;
    if (googleLiberado) return;
    /* só quando o caminho estiver livre; senão tenta de novo daqui a pouco */
    if (ocupado()) { setTimeout(permitirGoogle, 10000); return; }
    googleLiberado = true;
    raiz.classList.remove('jb-cad-sem-google');
    var f = googlePendente.splice(0, googlePendente.length);
    for (var i = 0; i < f.length; i++) f[i]();
  }

  raiz.classList.add('jb-cad-sem-google');
  /* na 2ª página da visita o cliente já se ambientou: solta antes */
  if (paginas >= 2) ESPERA_GOOGLE = 20000;

  (function () {
    var guardado = window.google;
    try {
      Object.defineProperty(window, 'google', {
        configurable: true,
        get: function () { return guardado; },
        set: function (v) { guardado = v; envolverGoogle(v); }
      });
    } catch (e) { }
    var t = setInterval(function () { envolverGoogle(window.google); }, 250);
    setTimeout(function () { clearInterval(t); }, 25000);
  })();

  /* --------------------------------------------------------------- estilo */
  var css = document.createElement('style');
  css.textContent =
    '.jb-cad-sem-google #credential_picker_container,' +
    '.jb-cad-sem-google div[id^="credential_picker"],' +
    '.jb-cad-sem-google iframe[src*="gsi/iframe"],' +
    '.jb-cad-sem-google iframe[src*="gsi/button"],' +
    '.jb-cad-sem-google #g_a11y_announcement,' +
    '.jb-cad-sem-google [class*="hiko"][class*="modal"],' +
    '.jb-cad-sem-google [id*="hiko"][id*="popup"]' +
    '{ display: none !important; }';
  (document.head || document.documentElement).appendChild(css);


  /* ------------------------------------------- teclado não abre sozinho
     Pop-up que nasce com o campo focado abre o teclado do celular antes de
     a pessoa ler o que apareceu. Aqui: nos 1,5 s seguintes à abertura de um
     pop-up, um foco que não veio de toque/clique é desfeito. */
  var ultimoToque = 0;
  ['pointerdown', 'touchstart', 'mousedown', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, function () { ultimoToque = agora(); }, true);
  });

  var CAIXAS = '[id^="jb-pop"], [class*="popup"], [class*="modal"], [role="dialog"], [class*="drawer"]';
  document.addEventListener('focusin', function (e) {
    var el = e.target;
    if (!el || !/^(INPUT|TEXTAREA)$/.test(el.tagName)) return;
    if (agora() - ultimoToque < 700) return;          /* foi a pessoa, tudo bem */
    var caixa = el.closest && el.closest(CAIXAS);
    if (!caixa) return;
    var nasceuAgora = !caixa.__jbVisto || (agora() - caixa.__jbVisto) < 1500;
    if (!nasceuAgora) return;
    try { el.blur(); } catch (er) { }
  }, true);

  /* marca quando cada caixa apareceu */
  setInterval(function () {
    var cx = document.querySelectorAll(CAIXAS);
    for (var i = 0; i < cx.length; i++) {
      var r = cx[i].getBoundingClientRect();
      var viva = r.height > 40 && r.width > 40;
      if (viva && !cx[i].__jbVisto) cx[i].__jbVisto = agora();
      if (!viva) cx[i].__jbVisto = 0;
    }
  }, 400);

  /* ----------------------------------------------------------------- API */
  window.jbFila = {
    pedir: pedir,
    liberar: liberar,
    ocupado: ocupado,
    paginas: paginas,
    rodar: rodar,
    permitirGoogle: permitirGoogle
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vigiarCookie);
  } else {
    vigiarCookie();
  }
  setInterval(rodar, 4000);
})();
